export default __webpack_public_path__ + "static/media/HouseMarketPlace.7d162eb6.png";